<template>
    <div>
        <!-- 头部 -->
        <v-header></v-header>
        <!-- 轮播图 -->
        <!--<v-banner></v-banner>-->
        <div class="product-list-wrap wrapCenter">
            <h2 class="product-title">找到你的专属唐麦耳机</h2>
            <div class="row product-list">
                <div class="col-sm-4 product-box" v-for="(item, index) in dataList" :key="index">
                    <a :href="item.url">
                        <img :src="item.imgsrc" width="100%" >
                        <div class="product-info">
                            <!--<h3>{{ item.title }}</h3>-->
                            <p>{{ item.desc }}</p>
                            <router-link class="to-detail" :to="{path: item.url}">了解更多 <i>&gt;</i></router-link>
                        </div>
                    </a>
                </div>
            </div>

            <!--<button class="btn btn-default btn-more">更多</button>-->
        </div>
        <!-- 尾部 -->
        <v-footer></v-footer>
        <!-- 回到顶部 -->
        <goto-top></goto-top>
    </div>
</template>
<script>
    import VHeader from "../components/header"
    //轮播图
    // import VBanner from "../components/banner"
    //尾部
    import VFooter from "../components/footer"
     // 回到顶部
    import GotoTop from "../components/gotoTop"

    export default{
        components:{
            VHeader,
            // VBanner,
            VFooter,
            GotoTop
        },
        data(){
            return {
                dataList:[
                    {
                        imgsrc: require("../assets/img/earphonelist/w0.jpg"),
                        title: "TANGMAI W0",
                        desc: "唐麦W0 真无线系列耳机",
                        url: "/product/w0"
                    },
                    {
                        imgsrc: require("../assets/img/earphonelist/w9.jpg"),
                        title: "TANGMAI W9",
                        desc: "唐麦W9 真无线系列耳机",
                        url: "/product/w9"
                    },
                    {
                        imgsrc: require("../assets/img/earphonelist/h2.jpg"),
                        title: "TANGMAI H2",
                        desc: "唐麦H2 头戴式蓝牙耳机",
                        url: "/product/H2"
                    },
                    {
                        imgsrc: require("../assets/img/earphonelist/h5.jpg"),
                        title: "TANGMAI H5",
                        desc: "H5 头戴式蓝牙耳机",
                        url: "/product/H5"
                    },
                    {
                        imgsrc: require("../assets/img/earphonelist/w10.jpg"),
                        title: "TANGMAI W10",
                        desc: "W10 真无线蓝牙耳机",
                        url: "/product/W10"
                    },
                    {
                        imgsrc: require("../assets/img/earphonelist/w11.jpg"),
                        title: "TANGMAI W11",
                        desc: "W11 真无线蓝牙耳机",
                        url: "/product/W11"
                    },
                    {
                        imgsrc: require("../assets/img/earphonelist/x3.jpg"),
                        title: "TANGMAI x3",
                        desc: "X3 真无线蓝牙耳机",
                        url: "/product/X3"
                    }
                ]
            }
        }
    }
</script>
<style scoped>
.product-list-wrap{
    padding-bottom: 60px;
    margin-top: 120px;
}
.product-title{
    font-size: 30px;
    color: #848484;
    margin: 60px 0 40px;
    text-align: center;
}


.product-box{
    border: 1px #e7e7e7 solid;
    /*margin-top: 20px;*/
    /*margin-bottom: 60px;*/
    margin-right: -1px;
    margin-bottom: -1px;
    padding: 10px 0;
}

.product-box .product-info{
    /*background: #e7e7e7;*/
    color: #848484;
    text-align: center;
    padding: 20px 0;
}

.product-box img{
    width: 80%;
    margin: 0 auto;
    display: block;
}

.product-info h3{
    font-size: 24px;
    font-weight: 400;
}

.product-info p{
    margin: 4px 0;
}

.product-info .to-detail{
    /*border: 1px #ad0000 solid;*/
    color: #ad0000;
    padding: 6px 30px;
    display: inline-block;
    
}

.product-info .to-detail i{
vertical-align: middle;
display: inline-block;
margin-top: -4px;
}

@media (max-width: 768px){
    .product-title{
        font-size: 1rem;
        
        margin: 1.8rem 0 1rem;
    }

    .product-list-wrap{
        margin-top: 60px;
    }

    .wrapCenter{
        overflow: hidden;
        padding: 0 0.6rem;
    }

    .product-info h3{
        font-size: 1rem;
    }

    .product-info p{
        font-size: 0.5rem;
    }

    .product-info .to-detail{
        /*margin-top: 0.8rem;*/
        font-size: 0.5rem;
        padding: 0.2rem 0.8rem;
    }

    /*.product-box{
        margin-top: 0rem;
        margin-bottom: 1rem;
    }*/

    .product-box img{
        width: 80%;
        margin-left: 10%;
    }
}


</style>


// WEBPACK FOOTER //
// src/pages/earphoneList_blue.vue